<app-page-title title="POS Cihazları" [breadcrumbItems]="breadCrumbItems"></app-page-title>

<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs nav-tabs-custom mb-3">
  <li [ngbNavItem]="1">
    <a ngbNavLink><i class="bx bx-credit-card-front me-1"></i>Cihazlar</a>
    <ng-template ngbNavContent>
      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
            <div class="small text-muted">
              Cihazı seri numarasıyla ekleyin, eşleştirin; ardından POS kasasını
              <a routerLink="/case/pos-terminals">POS Ayarları</a> ekranında cihaza bağlayın.
            </div>
            <button class="btn btn-sm btn-primary ms-auto" (click)="openDevice()">
              <i class="bx bx-plus me-1"></i>Cihaz Ekle
            </button>
          </div>

          <div *ngIf="loading" class="text-center py-3"><div class="spinner-border text-primary"></div></div>

          <div *ngIf="!loading && !devices.length" class="text-center text-muted py-4">
            Henüz POS cihazı tanımlanmamış.
          </div>

          <div class="table-responsive" *ngIf="!loading && devices.length">
            <table class="table table-hover align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th>Cihaz</th>
                  <th>Seri No</th>
                  <th>Şube</th>
                  <th>Sağlayıcı</th>
                  <th>Eşleştirme</th>
                  <th>Bağlı Kasalar</th>
                  <th class="text-center">Aktif</th>
                  <th style="width: 190px"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let device of devices" [class.text-muted]="!device.isActive">
                  <td class="fw-semibold">{{ device.name }}</td>
                  <td class="font-monospace">{{ device.serialNo }}</td>
                  <td>{{ device.branchName || 'Tüm şubeler' }}</td>
                  <td>{{ providerLabels[device.providerType] }}</td>
                  <td>
                    <span class="badge" [ngClass]="pairingBadge(device.pairingStatus)">{{ pairingLabels[device.pairingStatus] }}</span>
                    <div class="small text-muted" *ngIf="device.pairedAt">{{ device.pairedAt | date:'dd.MM.yyyy HH:mm' }}</div>
                    <div class="small text-warning" *ngIf="!device.hasDeviceSecret">
                      <i class="bx bx-error"></i> Cihaz kimliği yok
                    </div>
                  </td>
                  <td>
                    <span class="badge bg-light text-dark border me-1" *ngFor="let t of device.terminals">
                      {{ t.caseName || ('#' + t.caseId) }}
                      <span class="text-muted" *ngIf="t.providerPaymentMethodCode">· {{ t.providerPaymentMethodCode }}</span>
                    </span>
                    <span class="small text-muted" *ngIf="!device.terminals.length">—</span>
                  </td>
                  <td class="text-center">
                    <i class="bx" [ngClass]="device.isActive ? 'bx-check text-success' : 'bx-x text-muted'"></i>
                  </td>
                  <td class="text-end text-nowrap">
                    <span class="spinner-border spinner-border-sm text-primary me-2" *ngIf="busyDeviceId === device.id"></span>
                    <button class="btn btn-sm btn-outline-primary me-1" (click)="startPairing(device)"
                            [disabled]="busyDeviceId !== null || !device.isActive"
                            ngbTooltip="Eşleştir — kod cihaz ekranında onaylanır" container="body">
                      <i class="bx bx-link me-1"></i>{{ device.pairingStatus === PairingStatus.Paired ? 'Yeniden' : 'Eşleştir' }}
                    </button>
                    <div ngbDropdown class="d-inline-block" container="body">
                      <button class="btn btn-sm btn-light" ngbDropdownToggle [disabled]="busyDeviceId !== null">
                        <i class="bx bx-dots-horizontal-rounded"></i>
                      </button>
                      <div ngbDropdownMenu>
                        <button ngbDropdownItem (click)="openDevice(device)"><i class="bx bx-edit me-1"></i>Düzenle</button>
                        <button ngbDropdownItem (click)="renewPairing(device)" [disabled]="!device.isActive">
                          <i class="bx bx-revision me-1"></i>Yeni eşleştirme kodu
                        </button>
                        <button ngbDropdownItem (click)="provision(device)">
                          <i class="bx bx-key me-1"></i>Cihaz kimliğini yenile
                        </button>
                        <div class="dropdown-divider"></div>
                        <button ngbDropdownItem class="text-danger" (click)="deleteDevice(device)">
                          <i class="bx bx-trash me-1"></i>Sil
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ng-template>
  </li>
  <li [ngbNavItem]="2">
    <a ngbNavLink><i class="bx bx-cog me-1"></i>Entegrasyon Ayarı</a>
    <ng-template ngbNavContent>
      <app-pos-integration-settings></app-pos-integration-settings>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav"></div>

<!-- ══════════════ Cihaz formu ══════════════ -->
<ng-template #deviceModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ form.id ? 'Cihazı Düzenle' : 'Yeni POS Cihazı' }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-12">
        <label class="form-label">Cihaz adı <span class="text-danger">*</span></label>
        <input class="form-control" [(ngModel)]="form.name" maxlength="100" placeholder="Örn. Kasa 1 Pavo">
      </div>
      <div class="col-md-6">
        <label class="form-label">Seri numarası <span class="text-danger">*</span></label>
        <input class="form-control font-monospace text-uppercase" [(ngModel)]="form.serialNo" maxlength="50"
               placeholder="Örn. PAV86P012345">
      </div>
      <div class="col-md-6">
        <label class="form-label">Sağlayıcı</label>
        <select class="form-select" [(ngModel)]="form.providerType">
          <option *ngFor="let p of providers" [ngValue]="p">{{ providerLabels[p] }}</option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label">Şube</label>
        <select class="form-select" [(ngModel)]="form.branchId">
          <option [ngValue]="null">Tüm şubeler</option>
          <option *ngFor="let b of branches" [ngValue]="+b.value">{{ b.text }}</option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label">
          Üye iş yeri kimliği
          <i class="bx bx-info-circle text-muted" container="body"
             ngbTooltip="Boşsa entegrasyon ayarındaki MerchantUid. Cihaz farklı vergi numaralı bir şirkete aitse girin."></i>
        </label>
        <input class="form-control font-monospace" [(ngModel)]="form.merchantUid" maxlength="100" placeholder="Ayardaki">
      </div>
      <div class="col-12">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="pos-device-active" [(ngModel)]="form.isActive">
          <label class="form-check-label" for="pos-device-active">Aktif</label>
        </div>
      </div>
    </div>
    <div class="alert alert-warning py-2 small mt-3 mb-0" *ngIf="identityWillReset">
      Seri no, sağlayıcı ya da üye iş yeri değişti: cihaz kimliği ve eşleştirme sıfırlanır, cihaz yeniden eşleştirilmeli.
    </div>
    <div class="alert alert-danger py-2 mt-3 mb-0" *ngIf="formError">{{ formError }}</div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-light" (click)="modal.dismiss()" [disabled]="saving">Vazgeç</button>
    <button class="btn btn-primary" (click)="saveDevice()" [disabled]="saving">
      <span class="spinner-border spinner-border-sm me-1" *ngIf="saving"></span>Kaydet
    </button>
  </div>
</ng-template>

<!-- ══════════════ Eşleştirme ══════════════ -->
<ng-template #pairingModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Cihaz Eşleştirme — {{ pairingDevice?.name }}</h5>
    <button type="button" class="btn-close" (click)="modal.close()"></button>
  </div>
  <div class="modal-body text-center" *ngIf="pairingDevice">
    <ng-container [ngSwitch]="pairingDevice.pairingStatus">
      <ng-container *ngSwitchCase="PairingStatus.Paired">
        <i class="bx bx-check-circle text-success" style="font-size: 4rem"></i>
        <h5 class="mt-2">Cihaz eşleşti</h5>
        <p class="text-muted mb-0">
          Şimdi POS kasasını <a routerLink="/case/pos-terminals" (click)="modal.close()">POS Ayarları</a> ekranında bu cihaza bağlayın.
        </p>
      </ng-container>

      <ng-container *ngSwitchCase="PairingStatus.Pending">
        <p class="mb-2">Cihaz ekranında görünen eşleştirme isteğini bu kodla onaylayın:</p>
        <div class="display-5 font-monospace fw-bold my-3">{{ pairingDevice.pairingCode || '—' }}</div>
        <div class="small text-muted" *ngIf="isPolling">
          <span class="spinner-border spinner-border-sm me-1"></span>Onay bekleniyor…
        </div>
        <div class="small text-warning" *ngIf="pairingTimedOut">
          Onay 5 dakika içinde gelmedi.
        </div>
        <div class="small text-muted mt-2">
          İstek cihaz ekranında görünmüyorsa <b>Yeni kod al</b> ile yeni bir talep oluşturun.
        </div>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <i class="bx bx-error-circle text-danger" style="font-size: 4rem"></i>
        <h5 class="mt-2">Eşleştirme tamamlanmadı</h5>
        <p class="text-muted mb-0">Durum: {{ pairingLabels[pairingDevice.pairingStatus] }}. Yeni kodla yeniden deneyin.</p>
      </ng-container>
    </ng-container>

    <div class="alert alert-danger py-2 small mt-3 mb-0" *ngIf="pairingError">{{ pairingError }}</div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="renewInModal()"
            *ngIf="pairingDevice?.pairingStatus !== PairingStatus.Paired" [disabled]="renewing">
      <span class="spinner-border spinner-border-sm me-1" *ngIf="renewing"></span>
      <i class="bx bx-revision me-1" *ngIf="!renewing"></i>Yeni kod al
    </button>
    <button class="btn btn-outline-primary me-auto" (click)="checkPairingAgain()"
            *ngIf="pairingDevice?.pairingStatus === PairingStatus.Pending && !isPolling">
      <i class="bx bx-refresh me-1"></i>Tekrar kontrol et
    </button>
    <button class="btn btn-primary ms-auto" (click)="modal.close()">Kapat</button>
  </div>
</ng-template>
